module.exports = __webpack_public_path__ + "img/1584754746421912942.ad2ece24.jpg";